import React, {Suspense} from "react";
import {Heading} from "../../components";
import {useTranslation} from "react-i18next";
import MainProjectsTabs from "../ProjectsTabs";

export default function MainProjects () {

    const {t} = useTranslation();

    const MainProjectsGrids =[
        {
            number: "1",
            NumberColor: "text-[#191C30E5]",
            text: "text-[#191C30E5]",
            title: t("main.projects.card1.title"),
            description: t("main.projects.card1.description"),
            icon: "/images/services_1.svg",
            bg: "bg-[#EDEDED]"
        },
        {
            number: "2",
            NumberColor: "text-[#FFFFFF]",
            text: "text-[#FFFFFF]",
            title: t("main.projects.card2.title"),
            description: t("main.projects.card2.description"),
            icon: "/images/services_2.svg",
            bg: "bg-[#757575]"
        }
    ];

    return (
        <>
            <div className="flex flex-col items-center px-6 sm:px-[16px]">
                <div className="container-xs flex flex-col items-start gap-10">
                    <Heading
                        size="desktop_heading_4"
                        as="h2"
                        className="font-medium text-[#191c2fe5] leading-[33.6px] gap-4 uppercase">
                        {t("main.projects.headTitle")}
                    </Heading>
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-5 sm:gap-4 self-stretch">
                        <Suspense fallback={<div>Loading </div>}>
                            {MainProjectsGrids.map((d, index) => (
                                <MainProjectsTabs {...d} key={"grid" + index}/>
                            ))}
                        </Suspense>
                    </div>
                </div>
            </div>
        </>
    )
}